module.exports = {
	"name": "hexagram",
	"version": "1.2.0",
	"description": "hexagram",
	"main": "index.js",
	"license": "ISC",
	"scripts": {
		"clean": "rimraf dist",
		"format": "prettier-standard 'src/**/*.js'",
		"compile": "node build/scripts/compile",
		"build": "npm run clean && cross-env NODE_ENV=production npm run compile",
		"build:langs": "node build/scripts/extractMessages",
		"start": "cross-env NODE_ENV=development node build/scripts/start",
		"test": "cross-env NODE_ENV=test karma start build/karma.config",
		"test:watch": "npm test -- --watch",
		"lint": "eslint .",
		"lint:fix": "npm run lint -- --fix"
	},
	"author": "ADE",
	"lint-staged": {
		"linters": {
			"src/**/*.js": [
				"prettier-standard",
				"git add"
			]
		}
	},
	"dependencies": {
		"@ant-design/icons": "^4.2.2",
		"@antv/data-set": "^0.11.5",
		"antd": "^3.13.5",
		"axios": "^0.16.2",
		"bizcharts": "^3.5.8",
		"clusterfck": "^0.6.0",
		"compression": "^1.6.2",
		"copy-to-clipboard": "^3.0.8",
		"core-js": "^3.21.1",
		"downloadjs": "^1.4.7",
		"echarts": "^4.8.0",
		"echarts-liquidfill": "^2.0.6",
		"express": "^4.14.0",
		"extract-react-intl-messages": "^0.6.0",
		"file-saver": "^2.0.5",
		"font-awesome": "^4.7.0",
		"html2canvas": "^1.3.2",
		"image-promise": "^5.0.1",
		"jspdf": "^2.3.1",
		"jwt-decode": "^2.2.0",
		"lodash": "^4.17.4",
		"moment": "^2.18.1",
		"mqtt": "^3.0.0",
		"object-assign": "^4.1.1",
		"promise": "^7.1.1",
		"prop-types": "^15.5.10",
		"react": "^16.14.0",
		"react-dom": "^16.14.0",
		"react-fontawesome": "^1.6.1",
		"react-ga": "^2.3.5",
		"react-intl": "^2.4.0",
		"react-liquid-gauge": "^1.2.4",
		"react-redux": "^5.0.4",
		"react-router": "^3.0.0",
		"react-schedule-selector": "^3.0.0",
		"react-skycons": "^0.3.0",
		"react-table-drag-select": "^0.3.1",
		"redbox-react": "^1.3.6",
		"redux": "^3.6.0",
		"redux-thunk": "^2.2.0",
		"styled-components": "^5.3.3",
		"use-sound": "^2.0.1",
		"whatwg-fetch": "^2.0.3",
		"xlsx": "^0.17.1",
		"zrender": "^4.3.1"
	},
	"devDependencies": {
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.2.3",
		"babel-loader": "^7.0.0",
		"babel-plugin-react-intl": "^2.3.1",
		"babel-plugin-react-intl-auto": "^0.12.1",
		"babel-plugin-syntax-dynamic-import": "^6.18.0",
		"babel-plugin-transform-class-properties": "^6.24.1",
		"babel-plugin-transform-object-rest-spread": "^6.23.0",
		"babel-plugin-transform-runtime": "^6.15.0",
		"babel-preset-env": "^1.4.0",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-react": "^6.24.1",
		"babel-runtime": "^6.20.0",
		"chai": "^3.5.0",
		"chai-as-promised": "^6.0.0",
		"chai-enzyme": "^0.6.1",
		"chalk": "^1.1.3",
		"codecov": "^2.2.0",
		"connect-history-api-fallback": "^1.3.0",
		"cross-env": "^5.0.0",
		"css-loader": "^0.28.1",
		"dirty-chai": "^1.2.2",
		"enzyme": "^2.8.2",
		"eslint": "^3.19.0",
		"eslint-config-standard": "^10.2.1",
		"eslint-config-standard-react": "^5.0.0",
		"eslint-plugin-babel": "^4.1.1",
		"eslint-plugin-import": "^2.2.0",
		"eslint-plugin-node": "^4.2.2",
		"eslint-plugin-promise": "^3.5.0",
		"eslint-plugin-react": "^7.0.1",
		"eslint-plugin-standard": "^3.0.1",
		"extract-text-webpack-plugin": "^2.1.0",
		"figures": "^2.0.0",
		"file-loader": "^0.11.1",
		"fs-extra": "^3.0.1",
		"html-webpack-plugin": "^2.24.1",
		"husky": "^0.14.3",
		"intl-messageformat-parser": "^1.4.0",
		"karma": "^1.7.0",
		"karma-coverage": "^1.1.1",
		"karma-mocha": "^1.3.0",
		"karma-mocha-reporter": "^2.2.1",
		"karma-phantomjs-launcher": "^1.0.4",
		"karma-webpack-with-fast-source-maps": "^1.10.0",
		"lint-staged": "^4.0.2",
		"mocha": "^3.2.0",
		"node-sass": "^4.14.1",
		"phantomjs-prebuilt": "^2.1.14",
		"prettier-standard": "^6.0.0",
		"react-addons-test-utils": "^15.5.1",
		"react-test-renderer": "^15.5.4",
		"rimraf": "^2.6.1",
		"sass-loader": "^6.0.5",
		"sinon": "^2.2.0",
		"sinon-chai": "^2.10.0",
		"style-loader": "^0.17.0",
		"url-loader": "^0.5.8",
		"webpack": "^2.5.1",
		"webpack-dev-middleware": "^1.8.4",
		"webpack-hot-middleware": "^2.13.2",
		"why-did-you-update": "^1.0.8",
		"yargs": "^8.0.1"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 3468
// module chunks = 6